import ConsolidatorTracking from '@features/ConsolidatorTracking/ui/ConsolidatorTracking';

export default function ConsolidatorTrackingPage() {
    return <ConsolidatorTracking />
}